module.exports = __webpack_public_path__ + "img/verification_waiting.11bc9310.png";